//
//
//
//
//
//
//
//
//
//
//
//
//
//
import * as uni from '@/assets/webview.js';
import Vue from 'vue';
import { ACCESS_TOKEN } from '@/store/mutation-types';
import { getAction } from '@/api/manage';
import waterRegime from "./tab/waterRegime";
import workingCondition from "./tab/workingCondition";
import { appMethod } from '@/mixins/appMethod';
export default {
  mixins: [appMethod],
  components: {
    waterRegime: waterRegime,
    workingCondition: workingCondition
  },
  data: function data() {
    return {
      tabList: [{
        title: '汕尾水情',
        id: 1
      }, {
        title: '汕尾工情',
        id: 2
      }],
      selectedTab: 1
    };
  },
  created: function created() {
    // console.log('this.$route.query', this.$route.query)
    Vue.ls.set(ACCESS_TOKEN, this.$route.query.token, 7 * 24 * 60 * 60 * 1000);
    window.title = '';
  },
  mounted: function mounted() {
    console.log('uni', uni);
    console.log('wx', wx);
  },
  methods: {
    onToChangeTab: function onToChangeTab(item) {
      this.selectedTab = item.id;
    }
  }
};